import type {HeaderData} from '@commercial-website/data-layer'
import {Website} from '@commercial-website/data-layer'

import headerAt from './de-at/header'
import headerLu from './en-lu/header'
import headerEe from './et-ee/header'
import headerFi from './fi-fi/header'
import headerFrBe from './fr-be/header'
import headerIt from './it-it/header'
import headerNlBe from './nl-be/header'
import headerNo from './no-no/header'
import headerPt from './pt-pt/header'

export const secondaryLocaleHeaders: Record<string, HeaderData> = {
    'pt-pt': headerPt,
    'de-at': headerAt,
    'nl-be': headerNlBe,
    'fr-be': headerFrBe,
    'it-it': headerIt,
    'no-no': headerNo,
    'en-lu': headerLu,
    'et-ee': headerEe,
    'fi-fi': headerFi,
    'en-us': Website.getHeader(),
}
